import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e43b1d2e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e43b1d2e')) {
      api.createRecord('e43b1d2e', component.options)
    } else {
      api.reload('e43b1d2e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e43b1d2e&", function () {
      api.rerender('e43b1d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ib6qkiS439YT/JS/pricehelp.vue"
export default component.exports